/**
 * @desc 全局设置
 */
export const publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCsOD0oHb007bxLJwjkMZA5N44eZ3xUxm89jnHgpmP8Cy1+5b8gKWOiVMkHB4WAn2eblciwevpGNJH80b9G0ic52Shr5FlzOzek55NN24CSaTFNMjVFHkt6KtdUnGYanvyFVlRzwX119Oii7YQHhNYPSl6Zqk2I+N5gTkmtvpCJRQIDAQAB';
export const baseUrl = `${window.location.origin}/apis`;
export const authUrl = `${window.location.origin}/auth`;
export const vendorUrl = '/itbus/vendor';
export const componentUrl = '/itbus/components';
export const moduleUrl = `${location.pathname.slice(0, -1)}/modules`;
export default {vendorUrl, componentUrl, moduleUrl, publicKey, baseUrl};
